module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalelectricians.com.au/images/feature_3-2f17b07dffbe19ea31ad98cd0243cba1.jpeg";